export const AcademicErpSoftware = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 483 513"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_293_25600)">
      <path
        d="M472.215 343.792C472.215 420.699 368.938 482.979 241.546 482.979C114.134 482.979 10.8867 420.689 10.8867 343.792C10.8867 266.884 114.134 204.584 241.546 204.584C368.938 204.584 472.215 266.884 472.215 343.792Z"
        fill="#F7F7F7"
      />
    </g>
    <path
      d="M212.286 292.898V285.033L206.633 287.86L196.679 282.084C193.484 280.241 188.199 280.241 184.881 282.084L84.7269 339.965L79.074 337.138V345.003C78.9511 346.355 79.6884 347.707 81.5318 348.69L94.8038 356.309C97.9989 358.152 103.283 358.152 106.601 356.309L210.074 296.585C211.671 295.479 212.408 294.127 212.286 292.898Z"
      fill="#31700A"
    />
    <path
      d="M84.7269 339.842L79.074 337.015V344.88C78.9511 346.232 79.6884 347.584 81.5318 348.567L94.8038 356.186C96.4013 357.046 98.4904 357.538 100.457 357.538V330.748L84.7269 339.842Z"
      fill="#31700A"
    />
    <path
      d="M94.6809 347.83C97.876 349.673 103.16 349.673 106.478 347.83L209.951 288.106C213.146 286.262 213.146 283.19 209.951 281.347L196.679 273.728C193.484 271.884 188.199 271.884 184.881 273.728L81.5318 333.452C78.3367 335.295 78.3367 338.367 81.5318 340.211L94.6809 347.83Z"
      fill="#73BF43"
    />
    <path
      d="M126.018 327.307L118.767 323.129V286.262L165.342 259.473L126.018 327.307Z"
      fill="#15A87A"
    />
    <path
      d="M172.592 300.395L126.018 327.307V290.318L172.592 263.528V300.395Z"
      fill="#097A57"
    />
    <path
      d="M249.152 68.6262L242.393 64.8167C242.27 64.6938 242.148 64.5709 241.902 64.5709C241.287 64.3251 240.427 64.448 239.444 64.9396L44.7881 177.383C42.699 178.612 40.9785 181.561 40.9785 183.896V333.452C40.9785 334.681 41.3472 335.541 42.0845 335.91C42.2074 335.91 42.3303 336.032 42.4532 336.032L49.2121 339.842L50.5639 332.592L48.5976 333.452L239.567 223.22C241.656 221.992 243.377 219.042 243.377 216.707V72.8044L249.152 68.6262Z"
      fill="#097A57"
    />
    <path
      d="M242.393 64.8167C242.271 64.6938 242.148 64.5709 241.902 64.5709C241.287 64.3251 240.427 64.448 239.444 64.9396L44.7881 177.383C43.9279 177.874 43.0677 178.735 42.4532 179.718L172.593 261.808L239.567 223.22C241.656 221.992 243.377 219.042 243.377 216.707V72.8044L249.275 68.7491L242.393 64.8167Z"
      fill="#097A57"
    />
    <path
      d="M250.258 220.64C250.258 223.098 248.538 225.924 246.449 227.153L51.7927 339.596C49.7036 340.825 47.9832 339.842 47.9832 337.384V187.829C47.9832 185.371 49.7036 182.544 51.7927 181.315L246.572 68.8721C248.661 67.6432 250.381 68.6263 250.381 71.0841V220.64H250.258Z"
      fill="#097A57"
    />
    <path
      d="M246.572 209.703L51.7927 322.146V187.583L246.572 75.1394V209.703Z"
      fill="#ECF7FC"
    />
    <path
      d="M244.728 76.1225V208.228L51.7927 319.565V322.146L246.572 209.703V75.1394L244.728 76.1225Z"
      fill="white"
    />
    <path
      d="M228.384 108.197L150.718 153.051V148.504L228.384 103.65V108.197Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 116.061L107.093 186.108V181.684L228.384 111.637V116.061Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 124.049L107.093 194.096V189.672L228.384 119.625V124.049Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 132.037L107.093 202.084V197.537L228.384 127.49V132.037Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 139.902L107.093 209.949V205.525L228.384 135.478V139.902Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 147.89L107.093 217.936V213.512L228.384 143.466V147.89Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 163.865L150.718 208.72V204.173L228.384 159.318V163.865Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 171.73L107.093 241.777V237.353L228.384 167.306V171.73Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 179.718L107.093 249.765V245.341L228.384 175.294V179.718Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 187.706L107.093 257.752V253.205L228.384 183.159V187.706Z"
      fill="#CBE9F4"
    />
    <path
      d="M228.384 195.57L107.093 265.617V261.193L228.384 191.146V195.57Z"
      fill="#CBE9F4"
    />
    <path
      d="M165.219 240.056L107.093 273.605V269.181L165.219 235.51V240.056Z"
      fill="#CBE9F4"
    />
    <path
      d="M416.404 336.278L312.071 275.94L291.795 133.757L312.071 122.206L416.404 182.544V336.278Z"
      fill="#144682"
    />
    <path
      d="M411.243 333.575L393.67 342.546L292.286 139.042L311.58 127.982L411.243 185.494V333.575Z"
      fill="white"
    />
    <path
      d="M396.25 347.83L291.795 287.492V133.758L396.25 194.096V347.83Z"
      fill="#2D5CA0"
    />
    <path
      d="M392.932 349.919L288.477 289.58L268.323 147.398L288.477 135.846L392.932 196.062V349.919Z"
      fill="#1890C6"
    />
    <path
      d="M387.648 347.215L370.198 356.186L268.815 152.559L287.985 141.622L387.648 199.134V347.215Z"
      fill="white"
    />
    <path
      d="M372.656 361.348L268.323 301.132V147.398L372.656 207.614V361.348Z"
      fill="#55C3FE"
    />
    <path
      d="M294.99 153.911L286.019 148.996V130.071L290.566 136.338L294.99 133.389V153.911Z"
      fill="#EA4266"
    />
    <path
      d="M228.138 432.623L131.425 376.832V355.08L261.195 301.869L357.786 357.661L228.138 432.623Z"
      fill="#144682"
    />
    <path
      d="M261.195 294.865L136.217 352.868V372.531L228.138 425.618L357.786 350.779L261.195 294.865Z"
      fill="#E5E5E5"
    />
    <path
      d="M261.195 289.949L240.427 299.535V361.593H136.217V367.492L228.138 420.58L357.786 345.741L261.195 289.949Z"
      fill="#F4F4F4"
    />
    <path
      d="M261.195 285.279L240.427 294.865V361.593H136.217V362.945L228.138 416.033L357.786 341.071L261.195 285.279Z"
      fill="white"
    />
    <path
      d="M228.138 410.872L131.425 355.08L261.195 280.241L357.786 336.033L228.138 410.872Z"
      fill="#2D5CA0"
    />
    <path
      d="M228.384 403.13L136.586 350.165V329.52L259.844 279.012L351.642 331.978L228.384 403.13Z"
      fill="#1890C6"
    />
    <path
      d="M259.844 272.376L141.133 327.43V346.232L228.384 396.617L351.642 325.464L259.844 272.376Z"
      fill="#E5E5E5"
    />
    <path
      d="M259.844 267.583L240.182 276.677V335.664H141.133V341.44L228.384 391.824L351.642 320.671L259.844 267.583Z"
      fill="#F4F4F4"
    />
    <path
      d="M259.844 263.16L240.182 272.376V335.664H141.133V337.016L228.384 387.4L351.642 316.248L259.844 263.16Z"
      fill="white"
    />
    <path
      d="M228.384 382.608L136.586 329.52L259.844 258.367L351.642 311.455L228.384 382.608Z"
      fill="#55C3FE"
    />
    <path
      d="M229.121 377.323L141.256 326.57V306.908L259.106 258.613L346.972 309.243L229.121 377.323Z"
      fill="#EA4266"
    />
    <path
      d="M259.106 252.222L145.68 304.942V322.761L229.121 370.933L346.972 302.975L259.106 252.222Z"
      fill="#E5E5E5"
    />
    <path
      d="M259.106 247.676L240.304 256.401V312.807H145.68V318.214L229.121 366.386L346.972 298.429L259.106 247.676Z"
      fill="#F4F4F4"
    />
    <path
      d="M259.106 243.497L240.304 252.222V312.807H145.68V314.036L229.121 362.208L346.972 294.25L259.106 243.497Z"
      fill="white"
    />
    <path
      d="M229.121 357.661L141.256 306.908L259.106 238.95L346.972 289.581L229.121 357.661Z"
      fill="#FE7386"
    />
    <path
      d="M141.256 306.908L211.057 347.216L269.183 313.544L199.505 273.359L141.256 306.908Z"
      fill="#EF92A9"
    />
    <path
      d="M193.852 276.554L259.106 238.95L306.91 266.478L193.852 276.554Z"
      fill="#EF92A9"
    />
    <path
      d="M336.526 94.5556C336.526 94.5556 336.649 93.3268 339.967 100.823C343.285 108.319 335.297 132.16 333.331 134.74C331.365 137.321 307.402 144.694 302.117 136.584C305.435 134.863 302.24 132.405 302.855 128.596C312.686 132.037 322.394 124.172 325.466 121.714C330.505 117.659 327.433 104.878 336.526 94.5556Z"
      fill="#C7EBF9"
    />
    <path
      d="M298.308 215.97C298.308 215.97 291.057 221.5 289.46 223.712C287.862 226.047 291.303 228.382 297.202 225.309C303.1 222.237 304.329 221.377 305.435 220.763C306.541 220.148 306.295 219.165 306.173 217.567C305.804 215.847 298.308 215.97 298.308 215.97Z"
      fill="white"
    />
    <path
      d="M305.312 219.779C304.206 220.394 302.977 221.254 297.079 224.326C292.655 226.661 289.706 225.801 289.091 224.326C288.477 226.415 291.672 228.136 297.079 225.309C302.977 222.237 304.206 221.377 305.312 220.763C306.173 220.271 306.295 219.657 306.173 218.551C306.05 219.165 305.804 219.534 305.312 219.779Z"
      fill="#4C4C4C"
    />
    <path
      d="M360.858 145.8C360.858 145.8 360.612 162.267 345.989 165.954C331.365 169.518 316.004 177.014 316.004 177.014L306.418 218.551C306.418 218.551 304.329 219.534 302.363 219.165C299.045 218.551 297.816 216.093 297.816 216.093C297.816 216.093 296.71 186.354 299.782 173.45C302.978 160.547 329.153 145.432 329.153 145.432L360.858 145.8Z"
      fill="#112F5B"
    />
    <path
      d="M320.551 230.348C320.551 230.348 313.3 235.878 311.703 238.09C310.105 240.425 313.546 242.76 319.445 239.687C325.343 236.615 326.572 235.755 327.678 235.141C328.784 234.526 328.661 233.543 328.416 231.945C328.17 230.348 320.551 230.348 320.551 230.348Z"
      fill="white"
    />
    <path
      d="M327.678 234.157C326.572 234.772 325.343 235.632 319.445 238.704C315.021 241.039 312.071 240.179 311.457 238.704C310.843 240.793 314.038 242.514 319.445 239.687C325.343 236.615 326.572 235.755 327.678 235.14C328.539 234.649 328.661 234.034 328.539 232.928C328.416 233.543 328.17 233.912 327.678 234.157Z"
      fill="#4C4C4C"
    />
    <path
      d="M375.236 155.509C375.236 155.509 376.588 171.976 362.456 177.014C348.324 182.053 333.7 191.023 333.7 191.023L328.539 231.085C328.539 231.085 327.064 232.683 324.238 232.683C321.288 232.683 319.691 230.717 319.691 230.717C319.691 230.717 316.373 200.363 318.216 187.214C320.059 174.065 339.967 158.704 339.967 158.704L375.236 155.509Z"
      fill="#164072"
    />
    <path
      d="M327.064 146.784C327.064 146.784 325.466 97.5051 340.582 91.7293C355.574 85.9536 369.46 99.7171 375.359 112.989C381.258 126.261 379.66 149.364 375.359 157.966C354.591 172.099 326.449 153.542 327.064 146.784Z"
      fill="#097A57"
    />
    <path
      d="M375.236 112.866C369.338 99.5941 355.574 85.8305 340.459 91.6063C339.967 91.8521 339.476 92.0979 338.984 92.3436C350.044 93.6954 359.506 104.387 364.053 114.832C369.952 128.104 368.354 151.207 364.053 159.81C361.964 161.284 359.875 162.267 357.663 163.128C363.562 163.128 369.583 161.653 375.113 157.966C379.66 149.364 381.135 126.138 375.236 112.866Z"
      fill="#189E75"
    />
    <path
      d="M336.28 69.7321C336.28 69.7321 332.471 75.7536 335.912 88.7798C338.615 99.3483 339.107 105.247 343.408 105.616C347.832 106.107 360.981 102.789 359.629 91.8521C360.981 91.6063 363.685 86.5678 361.473 82.5125C359.383 78.4572 357.909 82.8812 357.909 82.8812C357.909 82.8812 358.032 74.1561 351.887 70.961C345.62 67.7658 336.28 69.7321 336.28 69.7321Z"
      fill="url(#paint0_linear_293_25600)"
    />
    <path
      d="M350.781 80.1777C350.781 79.6862 346.112 86.3222 338.492 84.2331C341.073 83.4957 341.688 81.6524 341.688 81.6524C341.688 81.6524 339.107 84.9704 334.806 83.8644C336.649 83.1271 337.509 82.2669 337.509 82.2669C337.509 82.2669 334.683 83.7415 331.856 82.6355C333.577 81.8982 333.331 80.7922 333.331 80.7922C333.331 80.7922 331.856 82.2669 328.784 79.6862C330.013 79.5633 329.89 73.9104 334.314 69.978C338.738 65.9226 342.302 65.0624 348.078 66.0455C346.603 64.5709 345.128 63.7106 343.039 64.0793C345.374 62.7275 350.29 65.0624 351.764 67.2744C356.311 65.554 364.913 68.5033 362.087 85.0933C362.087 84.7246 361.595 82.0211 359.998 81.4066C358.4 80.9151 357.049 84.1102 357.417 84.8475C357.786 85.7077 357.909 90.3775 357.909 90.3775L355.82 91.4835C355.82 91.4835 356.434 87.4282 354.959 86.0764C353.731 84.9704 351.15 86.4451 350.781 80.1777Z"
      fill="#112F5B"
    />
    <path
      d="M300.52 117.413L309.368 129.333L338.247 122.574L336.526 159.81L310.351 159.564L301.749 148.996L300.52 117.413Z"
      fill="white"
    />
    <path
      d="M300.52 112.375L309.368 129.333L310.351 159.564L301.749 148.996L300.52 112.375Z"
      fill="#E6F7FF"
    />
    <path
      d="M344.022 142.851C344.022 142.851 343.162 144.203 341.196 142.851C339.353 141.499 338.615 139.164 337.509 138.304C337.386 141.254 337.509 143.343 333.823 143.343C330.136 143.22 327.801 142.728 325.712 142.974C323.623 143.097 326.081 152.314 336.895 152.559C342.794 152.191 345.374 148.873 345.374 148.873L344.022 142.851Z"
      fill="url(#paint1_linear_293_25600)"
    />
    <path
      d="M301.011 131.054C301.011 131.054 302.978 135.109 304.206 135.601C305.435 136.092 304.452 142.851 300.766 140.639C296.956 138.427 298.676 131.3 301.011 131.054Z"
      fill="url(#paint2_linear_293_25600)"
    />
    <path
      d="M363.193 111.392C363.193 111.392 363.808 101.192 370.935 105.247C378.063 109.303 385.682 133.266 385.682 136.584C385.682 139.779 352.625 155.877 343.531 152.436C345.251 149.118 345.251 144.817 343.408 141.376C353.362 138.304 366.142 134.495 368.354 131.177C370.566 127.982 361.964 125.032 363.193 111.392Z"
      fill="#085C42"
    />
    <path
      d="M174.38 465.625L41.6476 388.965V383.927L217.638 435.728V440.656L174.38 465.625Z"
      fill="#149A71"
    />
    <path
      d="M174.38 465.625L41.6476 388.965V383.927L174.38 460.149V465.187V465.625Z"
      fill="#149A71"
    />
    <path
      d="M174.38 460.588L41.6476 383.927L84.7965 359.067L217.638 435.728L174.38 460.588Z"
      fill="#097A57"
    />
    <path
      d="M88.739 373.085L79.9778 368.048V366.953L94.3242 368.705V369.8L88.739 373.085Z"
      fill="#32A5C4"
    />
    <path
      d="M88.739 371.99L79.9778 366.952L85.563 363.667L94.3242 368.705L88.739 371.99Z"
      fill="#ADF8FF"
    />
    <path
      d="M98.0478 378.452L89.2866 373.414V372.319L103.743 374.181V375.276L98.0478 378.452Z"
      fill="#32A5C4"
    />
    <path
      d="M98.0478 377.466L89.2866 372.319L94.9814 369.143L103.743 374.181L98.0478 377.466Z"
      fill="#ADF8FF"
    />
    <path
      d="M107.466 383.927L98.705 378.89V377.794L113.051 379.547V380.642L107.466 383.927Z"
      fill="#32A5C4"
    />
    <path
      d="M107.466 382.832L98.705 377.794L104.29 374.509L113.051 379.547L107.466 382.832Z"
      fill="#ADF8FF"
    />
    <path
      d="M116.775 389.294L108.014 384.256V383.161L122.47 385.023V386.008L116.775 389.294Z"
      fill="#32A5C4"
    />
    <path
      d="M116.775 388.198L108.014 383.161L113.708 379.985L122.47 385.023L116.775 388.198Z"
      fill="#ADF8FF"
    />
    <path
      d="M126.193 394.769L117.432 389.732V388.636L131.778 390.389V391.484L126.193 394.769Z"
      fill="#32A5C4"
    />
    <path
      d="M126.193 393.674L117.432 388.637L123.017 385.351L131.778 390.389L126.193 393.674Z"
      fill="#ADF8FF"
    />
    <path
      d="M135.502 400.136L126.741 395.098V394.003L141.197 395.865V396.85L135.502 400.136Z"
      fill="#32A5C4"
    />
    <path
      d="M135.502 399.041L126.741 394.003L132.435 390.827L141.197 395.865L135.502 399.041Z"
      fill="#ADF8FF"
    />
    <path
      d="M144.92 405.611L136.159 400.574V399.479L150.615 401.231V402.326L144.92 405.611Z"
      fill="#32A5C4"
    />
    <path
      d="M144.92 404.516L136.159 399.479L141.854 396.193L150.615 401.231L144.92 404.516Z"
      fill="#ADF8FF"
    />
    <path
      d="M154.338 410.978L145.577 405.94V404.845L159.924 406.706V407.692L154.338 410.978Z"
      fill="#32A5C4"
    />
    <path
      d="M154.338 409.882L145.577 404.845L151.163 401.559L159.924 406.707L154.338 409.882Z"
      fill="#ADF8FF"
    />
    <path
      d="M163.647 416.453L154.886 411.306V410.32L169.342 412.073V413.168L163.647 416.453Z"
      fill="#32A5C4"
    />
    <path
      d="M163.647 415.358L154.886 410.32L160.581 407.035L169.342 412.073L163.647 415.358Z"
      fill="#ADF8FF"
    />
    <path
      d="M173.066 421.82L164.304 416.782V415.687L178.651 417.549V418.534L173.066 421.82Z"
      fill="#32A5C4"
    />
    <path
      d="M173.066 420.725L164.304 415.687L169.89 412.401L178.651 417.549L173.066 420.725Z"
      fill="#ADF8FF"
    />
    <path
      d="M182.374 427.295L173.613 422.148V421.162L188.069 422.915V424.01L182.374 427.295Z"
      fill="#32A5C4"
    />
    <path
      d="M182.374 426.2L173.613 421.162L179.308 417.877L188.069 422.915L182.374 426.2Z"
      fill="#ADF8FF"
    />
    <path
      d="M191.793 432.661L183.031 427.624V426.529L197.378 428.281V429.376L191.793 432.661Z"
      fill="#32A5C4"
    />
    <path
      d="M191.793 431.566L183.031 426.529L188.617 423.243L197.378 428.281L191.793 431.566Z"
      fill="#ADF8FF"
    />
    <path
      d="M201.101 438.028L192.34 432.99V432.005L206.796 433.757V434.852L201.101 438.028Z"
      fill="#32A5C4"
    />
    <path
      d="M201.101 437.042L192.34 432.004L198.035 428.719L206.796 433.757L201.101 437.042Z"
      fill="#ADF8FF"
    />
    <path
      d="M86.5488 380.313L72.6404 372.209V371.114L92.134 376.042V377.028L86.5488 380.313Z"
      fill="#32A5C4"
    />
    <path
      d="M86.5488 379.218L72.6404 371.114L78.3352 367.938L92.134 376.042L86.5488 379.218Z"
      fill="#ADF8FF"
    />
    <path
      d="M95.8574 385.789L87.0962 380.642V379.656L101.552 381.408V382.503L95.8574 385.789Z"
      fill="#32A5C4"
    />
    <path
      d="M95.8575 384.694L87.0963 379.656L92.7911 376.371L101.552 381.408L95.8575 384.694Z"
      fill="#ADF8FF"
    />
    <path
      d="M105.276 391.155L96.5145 386.118V385.022L110.861 386.884V387.87L105.276 391.155Z"
      fill="#32A5C4"
    />
    <path
      d="M105.276 390.06L96.5145 385.022L102.1 381.737L110.861 386.884L105.276 390.06Z"
      fill="#ADF8FF"
    />
    <path
      d="M114.584 396.631L105.823 391.484V390.498L120.279 392.25V393.345L114.584 396.631Z"
      fill="#32A5C4"
    />
    <path
      d="M114.584 395.536L105.823 390.498L111.518 387.213L120.279 392.25L114.584 395.536Z"
      fill="#ADF8FF"
    />
    <path
      d="M124.003 401.997L115.242 396.959V395.864L129.588 397.617V398.712L124.003 401.997Z"
      fill="#32A5C4"
    />
    <path
      d="M124.003 400.902L115.242 395.864L120.827 392.579L129.588 397.617L124.003 400.902Z"
      fill="#ADF8FF"
    />
    <path
      d="M133.311 407.363L124.55 402.326V401.34L139.006 403.092V404.187L133.311 407.363Z"
      fill="#32A5C4"
    />
    <path
      d="M133.311 406.378L124.55 401.34L130.245 398.055L139.006 403.092L133.311 406.378Z"
      fill="#ADF8FF"
    />
    <path
      d="M142.73 412.839L133.968 407.801V406.706L148.315 408.459V409.554L142.73 412.839Z"
      fill="#32A5C4"
    />
    <path
      d="M142.73 411.744L133.969 406.706L139.554 403.421L148.315 408.459L142.73 411.744Z"
      fill="#ADF8FF"
    />
    <path
      d="M152.039 418.205L143.277 413.168V412.073L157.733 413.934V415.029L152.039 418.205Z"
      fill="#32A5C4"
    />
    <path
      d="M152.039 417.22L143.277 412.073L148.972 408.897L157.733 413.934L152.039 417.22Z"
      fill="#ADF8FF"
    />
    <path
      d="M161.457 423.681L152.696 418.643V417.548L167.152 419.301V420.396L161.457 423.681Z"
      fill="#32A5C4"
    />
    <path
      d="M161.457 422.586L152.696 417.548L158.39 414.263L167.152 419.301L161.457 422.586Z"
      fill="#ADF8FF"
    />
    <path
      d="M170.875 429.047L162.114 424.01V422.915L176.46 424.776V425.871L170.875 429.047Z"
      fill="#32A5C4"
    />
    <path
      d="M170.875 428.062L162.114 422.914L167.699 419.739L176.46 424.776L170.875 428.062Z"
      fill="#ADF8FF"
    />
    <path
      d="M180.184 434.523L171.423 429.486V428.39L185.879 430.143V431.238L180.184 434.523Z"
      fill="#32A5C4"
    />
    <path
      d="M180.184 433.428L171.423 428.39L177.118 425.105L185.879 430.143L180.184 433.428Z"
      fill="#ADF8FF"
    />
    <path
      d="M193.764 442.408L180.841 434.852V433.757L199.458 438.028V439.123L193.764 442.408Z"
      fill="#32A5C4"
    />
    <path
      d="M193.764 441.313L180.841 433.756L186.426 430.581L199.458 438.028L193.764 441.313Z"
      fill="#ADF8FF"
    />
    <path
      d="M75.5972 382.613L65.1932 376.481V375.495L80.5253 377.795V378.89L75.5972 382.613Z"
      fill="#32A5C4"
    />
    <path
      d="M75.9257 381.737L65.1932 375.495L70.888 372.209L81.6205 378.452L75.9257 381.737Z"
      fill="#ADF8FF"
    />
    <path
      d="M84.2489 387.541L75.4877 382.504V381.408L89.9436 383.27V384.256L84.2489 387.541Z"
      fill="#32A5C4"
    />
    <path
      d="M84.2489 386.446L75.4877 381.408L81.1824 378.123L89.9436 383.27L84.2489 386.446Z"
      fill="#ADF8FF"
    />
    <path
      d="M93.6672 393.017L84.906 387.87V386.884L99.2525 388.637V389.732L93.6672 393.017Z"
      fill="#32A5C4"
    />
    <path
      d="M93.6672 391.922L84.906 386.884L90.4913 383.599L99.2525 388.637L93.6672 391.922Z"
      fill="#ADF8FF"
    />
    <path
      d="M102.976 398.383L94.2148 393.346V392.25L108.671 394.112V395.098L102.976 398.383Z"
      fill="#32A5C4"
    />
    <path
      d="M102.976 397.288L94.2148 392.251L99.9096 388.965L108.671 394.112L102.976 397.288Z"
      fill="#ADF8FF"
    />
    <path
      d="M112.394 403.859L103.633 398.712V397.726L117.979 399.479V400.574L112.394 403.859Z"
      fill="#32A5C4"
    />
    <path
      d="M112.394 402.764L103.633 397.726L109.328 394.441L117.979 399.479L112.394 402.764Z"
      fill="#ADF8FF"
    />
    <path
      d="M121.703 409.225L113.051 404.188V403.093L127.398 404.845V405.94L121.703 409.225Z"
      fill="#32A5C4"
    />
    <path
      d="M121.703 408.13L113.051 403.093L118.636 399.807L127.398 404.845L121.703 408.13Z"
      fill="#ADF8FF"
    />
    <path
      d="M131.121 414.591L122.36 409.554V408.568L136.816 410.32V411.416L131.121 414.591Z"
      fill="#32A5C4"
    />
    <path
      d="M131.121 413.606L122.36 408.568L128.055 405.283L136.816 410.32L131.121 413.606Z"
      fill="#ADF8FF"
    />
    <path
      d="M140.54 420.067L131.778 415.029V413.934L146.125 415.687V416.782L140.54 420.067Z"
      fill="#32A5C4"
    />
    <path
      d="M140.54 418.972L131.778 413.934L137.364 410.649L146.125 415.687L140.54 418.972Z"
      fill="#ADF8FF"
    />
    <path
      d="M149.848 425.434L141.087 420.396V419.301L155.543 421.163V422.258L149.848 425.434Z"
      fill="#32A5C4"
    />
    <path
      d="M149.848 424.448L141.087 419.301L146.782 416.125L155.543 421.162L149.848 424.448Z"
      fill="#ADF8FF"
    />
    <path
      d="M159.267 430.909L150.505 425.872V424.776L164.852 426.529V427.624L159.267 430.909Z"
      fill="#32A5C4"
    />
    <path
      d="M159.267 429.814L150.505 424.776L156.091 421.491L164.852 426.529L159.267 429.814Z"
      fill="#ADF8FF"
    />
    <path
      d="M168.575 436.276L159.814 431.238V430.143L174.27 432.005V433.1L168.575 436.276Z"
      fill="#32A5C4"
    />
    <path
      d="M168.575 435.29L159.814 430.143L165.509 426.967L174.27 432.004L168.575 435.29Z"
      fill="#ADF8FF"
    />
    <path
      d="M177.994 441.751L169.233 436.714V435.619L183.579 437.371V438.466L177.994 441.751Z"
      fill="#32A5C4"
    />
    <path
      d="M177.994 440.656L169.232 435.618L174.818 432.333L183.579 437.371L177.994 440.656Z"
      fill="#ADF8FF"
    />
    <path
      d="M186.426 446.57L178.541 442.08V440.985L192.012 442.299V443.285L186.426 446.57Z"
      fill="#32A5C4"
    />
    <path
      d="M186.426 445.475L178.541 440.985L184.236 437.809L192.012 442.299L186.426 445.475Z"
      fill="#ADF8FF"
    />
    <path
      d="M72.7498 389.403L57.7462 380.751V379.766L78.335 385.022V386.117L72.7498 389.403Z"
      fill="#32A5C4"
    />
    <path
      d="M72.7498 388.308L57.7462 379.766L63.441 376.48L78.335 385.022L72.7498 388.308Z"
      fill="#ADF8FF"
    />
    <path
      d="M82.0586 394.769L73.2974 389.732V388.746L87.7533 390.498V391.593L82.0586 394.769Z"
      fill="#32A5C4"
    />
    <path
      d="M82.0586 393.784L73.2974 388.746L78.9921 385.46L87.7533 390.498L82.0586 393.784Z"
      fill="#ADF8FF"
    />
    <path
      d="M91.4768 400.245L82.7156 395.207V394.112L97.062 395.864V396.959L91.4768 400.245Z"
      fill="#32A5C4"
    />
    <path
      d="M91.4768 399.15L82.7156 394.112L88.3008 390.827L97.062 395.864L91.4768 399.15Z"
      fill="#ADF8FF"
    />
    <path
      d="M100.786 405.611L92.0244 400.574V399.479L106.48 401.34V402.435L100.786 405.611Z"
      fill="#32A5C4"
    />
    <path
      d="M100.786 404.626L92.0244 399.478L97.7192 396.302L106.48 401.34L100.786 404.626Z"
      fill="#ADF8FF"
    />
    <path
      d="M110.204 411.087L101.443 406.049V404.954L115.789 406.706V407.801L110.204 411.087Z"
      fill="#32A5C4"
    />
    <path
      d="M110.204 409.992L101.443 404.954L107.028 401.669L115.789 406.706L110.204 409.992Z"
      fill="#ADF8FF"
    />
    <path
      d="M119.513 416.453L110.751 411.416V410.321L125.207 412.182V413.277L119.513 416.453Z"
      fill="#32A5C4"
    />
    <path
      d="M119.513 415.468L110.751 410.32L116.446 407.145L125.207 412.182L119.513 415.468Z"
      fill="#ADF8FF"
    />
    <path
      d="M128.931 421.929L120.17 416.891V415.796L134.516 417.548V418.644L128.931 421.929Z"
      fill="#32A5C4"
    />
    <path
      d="M128.931 420.834L120.17 415.796L125.865 412.511L134.516 417.548L128.931 420.834Z"
      fill="#ADF8FF"
    />
    <path
      d="M138.24 427.295L129.588 422.258V421.163L143.934 423.024V424.01L138.24 427.295Z"
      fill="#32A5C4"
    />
    <path
      d="M138.24 426.2L129.588 421.162L135.173 417.987L143.934 423.024L138.24 426.2Z"
      fill="#ADF8FF"
    />
    <path
      d="M147.658 432.771L138.897 427.733V426.638L153.353 428.39V429.486L147.658 432.771Z"
      fill="#32A5C4"
    />
    <path
      d="M147.658 431.676L138.897 426.638L144.591 423.353L153.353 428.39L147.658 431.676Z"
      fill="#ADF8FF"
    />
    <path
      d="M157.076 438.137L148.315 433.099V432.004L162.662 433.866V434.852L157.076 438.137Z"
      fill="#32A5C4"
    />
    <path
      d="M157.076 437.042L148.315 432.004L153.9 428.719L162.662 433.866L157.076 437.042Z"
      fill="#ADF8FF"
    />
    <path
      d="M166.385 443.613L157.624 438.575V437.48L172.08 439.232V440.327L166.385 443.613Z"
      fill="#32A5C4"
    />
    <path
      d="M166.385 442.518L157.624 437.48L163.319 434.195L172.08 439.232L166.385 442.518Z"
      fill="#ADF8FF"
    />
    <path
      d="M179.089 450.841L167.042 443.941V442.846L184.674 446.46V447.555L179.089 450.841Z"
      fill="#32A5C4"
    />
    <path
      d="M179.089 449.746L167.042 442.846L172.627 439.561L184.674 446.46L179.089 449.746Z"
      fill="#ADF8FF"
    />
    <path
      d="M61.1413 391.155L50.5183 385.022V383.927L66.7265 386.884V387.979L61.1413 391.155Z"
      fill="#32A5C4"
    />
    <path
      d="M61.1413 390.17L50.5183 383.927L56.1036 380.642L66.7265 386.884L61.1413 390.17Z"
      fill="#ADF8FF"
    />
    <path
      d="M70.45 396.631L61.6888 391.593V390.498L76.1448 392.25V393.345L70.45 396.631Z"
      fill="#32A5C4"
    />
    <path
      d="M70.45 395.536L61.6888 390.498L67.3836 387.213L76.1448 392.25L70.45 395.536Z"
      fill="#ADF8FF"
    />
    <path
      d="M79.8682 401.997L71.1071 396.96V395.974L85.4535 397.726V398.821L79.8682 401.997Z"
      fill="#32A5C4"
    />
    <path
      d="M79.8682 401.012L71.1071 395.974L76.6923 392.688L85.4535 397.726L79.8682 401.012Z"
      fill="#ADF8FF"
    />
    <path
      d="M135.94 434.523L80.4158 402.435V401.34L141.525 430.143V431.238L135.94 434.523Z"
      fill="#32A5C4"
    />
    <path
      d="M135.94 433.428L80.4158 401.34L86.1105 398.055L141.525 430.143L135.94 433.428Z"
      fill="#ADF8FF"
    />
    <path
      d="M145.468 439.999L136.707 434.961V433.866L151.053 435.618V436.713L145.468 439.999Z"
      fill="#32A5C4"
    />
    <path
      d="M145.468 438.904L136.707 433.866L142.292 430.581L151.053 435.618L145.468 438.904Z"
      fill="#ADF8FF"
    />
    <path
      d="M154.776 445.365L146.015 440.327V439.232L160.471 441.094V442.08L154.776 445.365Z"
      fill="#32A5C4"
    />
    <path
      d="M154.776 444.27L146.015 439.232L151.71 435.947L160.471 441.094L154.776 444.27Z"
      fill="#ADF8FF"
    />
    <path
      d="M164.195 450.841L155.434 445.694V444.708L169.78 446.46V447.555L164.195 450.841Z"
      fill="#32A5C4"
    />
    <path
      d="M164.195 449.746L155.434 444.708L161.019 441.423L169.78 446.46L164.195 449.746Z"
      fill="#ADF8FF"
    />
    <path
      d="M171.751 455.112L164.742 451.169V450.074L177.337 450.841V451.826L171.751 455.112Z"
      fill="#32A5C4"
    />
    <path
      d="M171.751 454.017L164.742 450.074L170.437 446.789L177.337 450.841L171.751 454.017Z"
      fill="#ADF8FF"
    />
    <path
      d="M273.853 331.854L301.257 316.001L330.136 337.384L302.855 353.237L273.853 331.854Z"
      fill="#10AD7C"
    />
    <path
      d="M302.855 361.102L330.136 345.249V337.384L302.855 353.237V361.102Z"
      fill="#13D598"
    />
    <path
      d="M302.855 361.102L330.136 345.249L337.018 349.181L309.736 365.034L302.855 361.102Z"
      fill="#10AD7C"
    />
    <path
      d="M309.736 372.899L337.018 357.046V349.181L309.736 365.034V372.899Z"
      fill="#13D498"
    />
    <path
      d="M309.736 372.899L337.018 357.046L343.899 360.979L316.495 376.832L309.736 372.899Z"
      fill="#10AD7C"
    />
    <path
      d="M316.495 384.696L343.899 368.844V360.979L316.495 376.831V384.696Z"
      fill="#13D498"
    />
    <path
      d="M316.495 384.696L343.9 368.967L350.658 372.899L323.377 388.629L316.495 384.696Z"
      fill="#10AD7C"
    />
    <path
      d="M323.377 396.617L350.658 380.764V372.899L323.377 388.629V396.617Z"
      fill="#13D498"
    />
    <path
      d="M323.377 396.616L350.659 380.764L357.54 384.696L330.136 400.549L323.377 396.616Z"
      fill="#10AD7C"
    />
    <path
      d="M330.136 408.414L357.54 392.561V384.696L330.136 400.549V408.414Z"
      fill="#13D498"
    />
    <path
      d="M330.136 408.414L357.54 392.561L364.299 396.494L337.018 412.346L330.136 408.414Z"
      fill="#10AD7C"
    />
    <path
      d="M337.018 420.211L364.299 404.359V396.494L337.018 412.346V420.211Z"
      fill="#13D498"
    />
    <path
      d="M337.018 420.211L364.299 404.481L371.181 408.414L343.777 424.144L337.018 420.211Z"
      fill="#10AD7C"
    />
    <path
      d="M343.777 432.131L371.181 416.279V408.414L343.777 424.144V432.131Z"
      fill="#13D498"
    />
    <path
      d="M330.136 408.414V400.426L323.377 396.494V388.629L316.495 384.696V376.831L309.736 372.899V365.034L302.855 361.102V353.237L273.853 331.854L337.018 428.076L343.777 432.008V424.144L337.018 420.211V412.346L330.136 408.414Z"
      fill="#004F36"
    />
    <path
      d="M162.27 267.583V301.132C162.27 308.013 166.817 314.895 175.911 320.179C194.098 330.748 223.714 330.748 241.902 320.179C250.996 314.895 255.543 308.013 255.543 301.132V267.583H162.27Z"
      fill="#0A253F"
    />
    <path
      d="M207.124 311.209L127.124 265.002V262.79H287.125V265.002L207.124 311.209Z"
      fill="#0B2D4F"
    />
    <path
      d="M207.124 308.997L127.124 262.79L207.124 216.584L287.125 262.79L207.124 308.997Z"
      fill="#164072"
    />
    <path
      d="M251.364 313.544H248.538V285.156L206.51 264.019L207.739 261.562L251.364 283.436V313.544Z"
      fill="#FFD629"
    />
    <path
      d="M212.9 263.282C212.9 264.757 210.811 266.108 208.353 266.108C205.773 266.108 203.806 264.88 203.806 263.282C203.806 261.807 205.896 260.456 208.353 260.456C210.811 260.578 212.9 261.807 212.9 263.282Z"
      fill="#FFD629"
    />
    <path
      d="M253.208 326.324V312.192C253.208 310.471 251.733 308.997 250.013 308.997C248.292 308.997 246.818 310.471 246.818 312.192V326.324H253.208Z"
      fill="#FFF42C"
    />
    <path
      d="M342.794 0.0541992L258.123 33.2342L294.621 37.5353L342.794 0.0541992Z"
      fill="white"
    />
    <path
      d="M294.007 37.4124L299.659 53.2651L342.793 0.0541992L294.007 37.4124Z"
      fill="#CBCBCB"
    />
    <path
      d="M306.173 41.0991L299.66 53.2651L342.794 0.0541992L306.173 41.0991Z"
      fill="#898989"
    />
    <path
      d="M342.794 0.0541992L331.365 55.8457L306.173 41.0991L342.794 0.0541992Z"
      fill="white"
    />
    <path
      d="M319.936 321.409C318.707 321.409 317.355 321.409 316.127 321.409V318.951C319.445 318.951 322.64 318.951 325.835 318.951L325.958 321.409C323.991 321.409 321.902 321.409 319.936 321.409ZM306.295 321.04C303.469 320.917 300.52 320.671 297.57 320.426L296.464 320.303L296.71 317.845L297.816 317.968C300.765 318.214 303.715 318.459 306.541 318.582L306.295 321.04ZM335.912 320.917L335.666 318.459C338.984 318.214 342.179 317.845 345.374 317.476L345.743 319.934C342.425 320.303 339.23 320.548 335.912 320.917ZM286.633 319.074C283.315 318.582 280.12 318.091 276.925 317.476L277.417 315.018C280.489 315.633 283.807 316.124 287.002 316.616L286.633 319.074ZM355.451 318.336L354.959 315.879C358.155 315.264 361.35 314.527 364.545 313.789L365.159 316.124C361.964 316.985 358.769 317.722 355.451 318.336ZM267.217 315.387C264.022 314.65 260.704 313.667 257.631 312.806L258.369 310.471C261.441 311.455 264.513 312.315 267.708 313.052L267.217 315.387ZM374.622 313.544L373.884 311.209C376.957 310.226 380.152 309.12 383.101 307.891L383.961 310.226C381.012 311.332 377.817 312.561 374.622 313.544ZM248.292 309.611C245.22 308.382 242.147 307.154 239.198 305.679L240.304 303.467C243.131 304.819 246.203 306.17 249.275 307.276L248.292 309.611ZM393.055 306.17L391.949 303.958C394.898 302.484 397.725 300.886 400.428 299.289L401.657 301.378C398.954 303.098 396.004 304.696 393.055 306.17ZM230.473 301.009C227.524 299.289 224.82 297.445 222.117 295.602L223.591 293.636C226.172 295.479 228.876 297.322 231.702 298.92L230.473 301.009ZM410.014 295.848L408.539 293.882C411.12 291.915 413.7 289.826 416.035 287.737L417.633 289.58C415.298 291.792 412.717 293.882 410.014 295.848ZM214.498 289.335C212.04 287.123 209.705 284.665 207.493 282.207L209.336 280.609C211.425 283.067 213.637 285.279 216.095 287.491L214.498 289.335ZM424.76 282.576L422.917 280.978C425.129 278.52 427.095 275.94 428.816 273.359L430.905 274.711C428.939 277.414 426.972 279.995 424.76 282.576ZM201.471 274.219C199.628 271.516 197.907 268.566 196.433 265.617L198.645 264.511C200.119 267.338 201.717 270.164 203.56 272.867L201.471 274.219ZM435.943 266.109L433.731 265.003C435.206 262.053 436.435 259.104 437.418 256.155L439.753 256.892C438.647 259.964 437.418 263.036 435.943 266.109ZM192.377 256.523C191.271 253.451 190.288 250.256 189.551 246.938L191.886 246.323C192.623 249.519 193.606 252.591 194.589 255.54L192.377 256.523ZM442.088 247.184L439.63 246.815C440.121 243.866 440.367 240.916 440.367 238.09V237.23H442.825V238.09C442.825 241.039 442.579 244.111 442.088 247.184ZM187.831 237.23C187.462 234.035 187.216 230.717 187.093 227.276H189.551C189.674 230.594 189.797 233.789 190.288 236.984L187.831 237.23ZM439.384 227.644C438.77 224.572 437.909 221.377 436.803 218.428L439.138 217.567C440.367 220.763 441.227 223.958 441.842 227.153L439.384 227.644ZM189.797 217.567L187.339 217.445C187.585 214.249 187.953 210.931 188.445 207.613L190.903 207.982C190.411 211.054 190.043 214.372 189.797 217.567ZM432.625 209.703C431.028 206.999 429.184 204.296 427.218 201.715L429.184 200.24C431.273 202.821 433.24 205.647 434.837 208.474L432.625 209.703ZM192.869 198.397L190.534 197.782C191.271 194.587 192.255 191.392 193.238 188.197L195.573 188.934C194.589 192.129 193.606 195.202 192.869 198.397ZM199.013 179.963L196.801 178.98C198.153 175.908 199.505 172.836 201.103 170.009L203.315 171.115C201.717 173.942 200.365 176.891 199.013 179.963ZM208.23 162.759L206.141 161.407C207.861 158.827 209.705 156 211.548 153.174L213.637 154.525C211.671 157.475 209.828 160.178 208.23 162.759ZM219.167 146.538L217.201 145.186C219.044 142.482 221.011 139.902 222.977 137.198L224.943 138.673C222.977 141.253 221.011 143.957 219.167 146.538ZM230.719 130.685L228.753 129.21C230.719 126.63 232.685 123.926 234.651 121.345L236.618 122.82C234.528 125.401 232.562 127.981 230.719 130.685ZM242.516 114.955L240.55 113.481C242.516 110.9 244.605 108.319 246.571 105.739L248.538 107.213C246.449 109.794 244.482 112.375 242.516 114.955ZM254.559 99.4713L252.593 97.9966C254.682 95.4159 256.648 92.8353 258.737 90.2546L260.704 91.7293C258.615 94.3099 256.648 96.8906 254.559 99.4713ZM266.848 84.1102L264.882 82.5126C266.971 79.809 269.06 77.3513 271.026 74.8935L272.87 76.491C271.026 78.9488 268.937 81.4066 266.848 84.1102ZM279.26 68.8719L277.417 67.2744C279.751 64.4479 281.841 61.9902 283.684 59.6553L285.527 61.2528C283.684 63.5877 281.472 66.1684 279.26 68.8719Z"
      fill="white"
    />
    <path
      d="M80.6716 327.43C79.197 327.43 77.5994 327.43 76.0019 327.307L76.1248 324.849C79.5657 325.095 82.8836 324.972 85.833 324.849L85.9559 327.307C84.3583 327.307 82.515 327.43 80.6716 327.43ZM65.925 326.201C62.3612 325.587 59.1661 324.849 56.0939 323.743L56.8312 321.409C59.7805 322.392 62.8528 323.129 66.2937 323.743L65.925 326.201ZM96.0328 325.71L95.4183 323.375C98.6134 322.637 101.686 321.531 104.512 320.18L105.618 322.392C102.669 323.743 99.4736 324.849 96.0328 325.71ZM46.8772 319.565C43.805 317.722 41.1014 315.633 38.8894 313.175L40.7328 311.454C42.8219 313.667 45.4025 315.756 48.229 317.476L46.8772 319.565ZM114.343 316.862L112.869 314.895C115.326 312.929 117.661 310.594 119.627 308.014L121.594 309.488C119.382 312.315 116.924 314.772 114.343 316.862ZM33.1136 304.573C31.639 301.623 30.6559 298.305 29.9185 294.865L32.3763 294.373C32.9908 297.691 33.9739 300.763 35.3257 303.467L33.1136 304.573ZM127.001 301.132L124.789 300.026C126.263 297.199 127.492 294.25 128.475 291.055L130.81 291.792C129.704 294.987 128.475 298.183 127.001 301.132ZM28.9354 284.788V284.542C28.9354 281.47 29.1812 278.152 29.6728 274.711L32.1305 275.079C31.639 278.397 31.5161 281.593 31.5161 284.542V284.788H28.9354ZM133.145 281.961L130.687 281.47C131.302 278.397 131.671 275.079 131.916 271.761L134.374 271.884C134.128 275.325 133.76 278.766 133.145 281.961ZM33.9739 265.371L31.639 264.757C32.3763 261.562 33.3594 258.367 34.4654 255.049L36.8003 255.786C35.5714 259.104 34.7112 262.299 33.9739 265.371ZM132.162 261.93C132.162 258.735 131.916 255.417 131.671 252.099L134.128 251.853C134.497 255.294 134.62 258.612 134.62 261.93H132.162ZM130.442 242.268C129.95 239.073 129.336 235.878 128.598 232.56L131.056 232.068C131.793 235.386 132.408 238.704 132.899 241.899L130.442 242.268ZM126.263 222.975C125.403 219.902 124.42 216.707 123.437 213.512L125.772 212.775C126.755 215.97 127.738 219.165 128.598 222.36L126.263 222.975ZM120.365 204.05C119.382 200.855 118.399 197.659 117.538 194.464L119.873 193.85C120.733 197.045 121.594 200.24 122.577 203.312L120.365 204.05ZM115.326 184.756C114.712 181.438 114.097 178.12 113.606 174.925L116.064 174.556C116.555 177.751 117.17 181.069 117.784 184.265L115.326 184.756ZM112.377 164.971C112.131 161.653 111.885 158.212 111.763 155.017L114.22 154.894C114.343 158.089 114.589 161.407 114.835 164.725L112.377 164.971ZM114.22 144.94L111.763 144.817C111.885 141.499 112.008 138.058 112.377 134.863L114.835 135.109C114.466 138.304 114.22 141.622 114.22 144.94ZM116.064 125.401L113.606 125.032C114.22 121.714 114.835 118.396 115.695 115.201L118.03 115.815C117.293 118.888 116.555 122.083 116.064 125.401ZM120.979 106.353L118.644 105.493C119.873 102.175 121.225 99.1026 122.577 96.2761L124.789 97.3821C123.437 100.209 122.085 103.158 120.979 106.353ZM129.827 89.0257L127.861 87.551C129.827 84.7246 132.162 82.1439 134.497 79.809L136.217 81.5295C133.883 83.7415 131.793 86.3221 129.827 89.0257ZM190.166 77.2283C187.093 75.7537 184.021 74.5248 181.072 73.5417L181.809 71.2068C184.881 72.1899 187.954 73.5417 191.149 75.0163L190.166 77.2283ZM143.714 75.7537L142.485 73.6646C145.434 71.9441 148.629 70.4695 151.824 69.6092L152.562 71.9441C149.489 72.8043 146.54 74.1561 143.714 75.7537ZM171.609 71.0839C168.291 70.4695 165.096 70.3466 161.901 70.4695L161.778 68.0117C165.096 67.8888 168.414 68.1346 171.978 68.749L171.609 71.0839Z"
      fill="white"
    />
    <path
      d="M427.587 365.771L448.355 353.728V348.198L411.12 356.309L427.587 365.771Z"
      fill="#AAAAAA"
    />
    <path
      d="M427.587 360.241L448.355 348.198L431.888 338.613L411.12 350.656L427.587 360.241Z"
      fill="#FCFCFC"
    />
    <path
      d="M440.982 350.164L444.054 348.321L439.507 345.74L436.312 347.584L440.982 350.164Z"
      fill="#AAAAAA"
    />
    <path
      d="M439.507 346.232L436.681 347.707L436.312 347.584L439.507 345.74L444.054 348.321L443.686 348.567L439.507 346.232Z"
      fill="#4F4F4F"
    />
    <path
      d="M432.994 345.618L436.066 343.774L431.519 341.071L428.324 342.914L432.994 345.618Z"
      fill="#AAAAAA"
    />
    <path
      d="M431.519 341.562L428.693 343.16L428.324 342.914L431.519 341.071L436.066 343.774L435.698 344.02L431.519 341.562Z"
      fill="#4F4F4F"
    />
    <path
      d="M367.494 374.742L371.427 378.429C371.673 378.306 371.918 378.183 372.164 378.06L437.664 356.554V366.386L394.776 391.086C388.631 394.65 378.8 394.65 372.656 391.086L372.164 390.718C368.969 388.874 367.494 386.539 367.617 384.082V374.742H367.494Z"
      fill="#31700A"
    />
    <path
      d="M372.041 368.106L414.93 343.406L437.664 356.555L394.776 381.255C388.631 384.819 378.8 384.819 372.656 381.255L372.164 380.887C366.02 377.323 366.02 371.547 372.041 368.106Z"
      fill="#73BF43"
    />
    <path
      d="M376.097 378.06C379.783 380.272 385.928 380.272 389.614 378.06C393.301 375.848 393.301 372.407 389.614 370.195C385.928 367.983 379.783 367.983 376.097 370.195C372.287 372.284 372.41 375.848 376.097 378.06Z"
      fill="#3A850B"
    />
    <path
      d="M48.1062 73.5417C48.1062 73.5417 47.9833 82.3897 52.5302 84.2331C56.2168 83.4957 52.0386 74.0333 52.0386 74.0333L48.1062 73.5417Z"
      fill="#112F5B"
    />
    <path
      d="M104.389 144.449C105.004 144.08 105.495 143.466 105.864 142.851L102.792 144.572C103.652 144.572 104.389 144.572 104.389 144.449Z"
      fill="#E2E2E2"
    />
    <path
      d="M106.478 155.509C106.478 155.509 99.4736 156.123 97.9989 161.899C96.77 166.814 94.8038 163.865 95.1725 164.725C95.5412 165.585 99.1049 172.59 102.546 169.518C105.987 166.446 110.902 163.251 108.936 156.737C107.584 155.631 106.478 155.509 106.478 155.509Z"
      fill="#0B223D"
    />
    <path
      d="M87.4304 167.675C87.4304 167.675 80.4257 168.289 78.9511 174.065C77.7222 178.981 77.7222 179.226 78.0909 180.209C78.4595 181.07 80.0571 184.879 83.498 181.807C86.9389 178.735 93.6977 177.752 91.8544 171.361C90.3797 170.01 87.4304 167.675 87.4304 167.675Z"
      fill="#112F5B"
    />
    <path
      d="M75.2645 84.3559C75.2645 84.3559 75.1416 83.127 71.8236 90.6233C68.5056 98.1195 76.4934 121.96 78.4596 124.541C80.4259 127.121 104.389 134.495 109.673 126.384C106.355 124.663 109.551 122.206 108.936 118.396C99.105 121.837 84.9728 115.938 81.9005 113.481C76.8621 109.302 84.3583 94.6786 75.2645 84.3559Z"
      fill="url(#paint3_linear_293_25600)"
    />
    <path
      d="M112.623 205.77C112.623 205.77 120.856 211.3 122.454 213.512C124.051 215.724 120.611 218.182 114.712 215.11C108.813 212.037 107.584 211.177 106.478 210.563C105.372 209.948 105.372 206.753 106.478 204.91C107.339 203.435 112.623 205.77 112.623 205.77Z"
      fill="#FE7386"
    />
    <path
      d="M106.478 209.579C107.584 210.194 108.813 211.054 114.712 214.126C119.136 216.461 122.085 215.601 122.7 214.126C123.314 216.215 120.119 217.936 114.712 215.109C108.813 212.037 107.584 211.177 106.478 210.563C105.618 210.071 105.495 209.457 105.618 208.351C105.741 208.842 105.987 209.211 106.478 209.579Z"
      fill="#4C4C4C"
    />
    <path
      d="M50.9326 135.478C50.9326 135.478 51.1784 151.945 65.8022 155.632C80.4259 159.195 99.4737 164.848 99.4737 164.848L106.724 206.63C106.724 206.63 109.182 209.088 111.148 208.351C112.869 207.614 112.5 205.893 112.5 205.893C112.5 205.893 113.483 174.925 110.78 162.022C108.813 152.436 74.896 138.058 74.896 138.058L50.9326 135.478Z"
      fill="url(#paint4_linear_293_25600)"
    />
    <path
      d="M108.936 156.86C101.071 145.8 82.6379 135.232 82.6379 135.232L50.9326 135.601C50.9326 135.601 51.1784 152.068 65.8022 155.754C78.0911 158.827 93.4522 166.446 97.1388 168.166C97.2617 161.161 102.423 153.911 108.936 156.86Z"
      fill="#112F5B"
    />
    <path
      d="M91.2401 220.148C91.2401 220.148 98.4906 225.678 100.088 227.89C101.686 230.102 98.2448 232.56 92.3462 229.488C86.4475 226.415 85.2186 225.555 84.1126 224.941C83.0066 224.326 83.0066 220.885 84.2355 218.673C85.0957 217.199 91.2401 220.148 91.2401 220.148Z"
      fill="#FE7386"
    />
    <path
      d="M84.1126 223.958C85.2186 224.572 86.4475 225.432 92.3462 228.505C96.7702 230.839 99.7195 229.979 100.334 228.505C100.948 230.594 97.7533 232.314 92.3462 229.488C86.4475 226.415 85.2186 225.555 84.1126 224.941C83.2524 224.449 83.1295 223.835 83.2524 222.729C83.3753 223.22 83.6211 223.589 84.1126 223.958Z"
      fill="#4C4C4C"
    />
    <path
      d="M36.5545 145.309C36.5545 145.309 35.2027 161.776 49.335 166.814C63.4672 171.853 80.9174 178.243 80.9174 178.243L84.3583 219.657C84.3583 219.657 85.5872 221.5 88.4136 221.5C91.363 221.5 91.2401 220.025 91.2401 220.025C91.2401 220.025 94.3123 190.04 92.4689 176.891C90.6256 163.742 71.9465 148.381 71.9465 148.381L36.5545 145.309Z"
      fill="url(#paint5_linear_293_25600)"
    />
    <path
      d="M91.7316 171.238C86.3245 159.81 71.8236 148.504 71.8236 148.504L36.4316 145.309C36.4316 145.309 35.0798 161.776 49.212 166.814C61.6238 171.238 76.0018 180.086 78.8283 181.807C80.7945 175.539 83.7438 169.272 91.7316 171.238Z"
      fill="#164072"
    />
    <path
      d="M84.7269 136.584C84.7269 136.584 86.3245 87.3054 71.2091 81.5296C56.2167 75.7539 42.3303 89.5174 36.4316 102.789C30.5329 116.061 32.1305 139.165 36.4316 147.767C57.1998 161.899 85.3414 143.343 84.7269 136.584Z"
      fill="#097A57"
    />
    <path
      d="M36.5546 102.666C42.4532 89.3944 56.2168 75.6308 71.3321 81.4066C71.8237 81.6524 72.3152 81.8982 72.8068 82.1439C61.7468 83.4957 52.2844 94.187 47.7375 104.633C41.8388 117.905 43.4364 141.008 47.7375 149.61C49.8266 151.085 51.9157 152.068 54.1277 152.928C48.229 152.928 42.2075 151.453 36.6775 147.767C32.1306 139.041 30.6559 115.938 36.5546 102.666Z"
      fill="#189E75"
    />
    <path
      d="M75.5103 59.4095C75.5103 59.4095 79.3199 65.4311 75.879 78.4573C73.1754 89.0257 72.6839 94.9244 68.3828 95.2931C63.9588 95.7846 50.8097 92.4666 52.1615 81.5295C50.8097 81.2837 48.1061 76.2453 50.3181 72.19C52.4072 68.1346 53.8819 72.5586 53.8819 72.5586C53.8819 72.5586 53.759 63.8335 60.0263 60.6384C66.1708 57.5662 75.5103 59.4095 75.5103 59.4095Z"
      fill="url(#paint6_linear_293_25600)"
    />
    <path
      d="M61.0094 69.978C61.0094 69.4865 65.6792 76.1225 73.2983 74.0334C70.7176 73.296 70.1032 71.4527 70.1032 71.4527C70.1032 71.4527 72.6838 74.7707 76.9849 73.6647C75.1416 72.9274 74.2814 72.0671 74.2814 72.0671C74.2814 72.0671 77.1078 73.5418 79.9343 72.4358C78.2138 71.6985 78.4596 70.5925 78.4596 70.5925C78.4596 70.5925 79.9343 72.0671 83.0065 69.4865C81.7776 69.3636 81.9005 63.7107 77.4765 59.7783C73.0525 55.7229 69.4887 54.8627 63.7129 55.8458C65.1876 54.3711 66.6623 53.5109 68.7514 53.8796C66.4165 52.5278 61.5009 54.8627 60.0263 57.0747C55.4794 55.3543 46.8772 58.3036 49.7036 74.8936C49.7036 74.5249 50.1952 71.8214 51.7927 71.2069C53.3903 70.7154 54.7421 73.9105 54.3734 74.6478C54.0047 75.508 53.8818 80.1778 53.8818 80.1778L55.9709 81.2838C55.9709 81.2838 55.3565 77.2285 56.8312 75.8767C58.0601 74.7707 60.6407 76.2454 61.0094 69.978Z"
      fill="#112F5B"
    />
    <path
      d="M111.271 107.09L102.423 119.133L73.5441 112.375L75.2645 149.61L101.44 149.364L110.042 138.796L111.271 107.09Z"
      fill="white"
    />
    <path
      d="M111.271 102.052L102.423 119.134L101.44 149.364L110.042 138.796L111.271 102.052Z"
      fill="#E6F7FF"
    />
    <path
      d="M110.779 120.854C110.779 120.854 108.813 124.909 107.584 125.401C106.355 125.892 107.338 132.651 111.025 130.439C114.835 128.227 113.114 120.977 110.779 120.854Z"
      fill="url(#paint7_linear_293_25600)"
    />
    <path
      d="M86.0788 132.529C83.9897 132.406 81.6548 132.897 77.9681 132.897C74.2814 133.02 74.4043 130.931 74.2814 127.859C73.1754 128.719 72.4381 131.054 70.5948 132.406C68.7514 133.757 67.7683 132.406 67.7683 132.406L67.3997 132.651C54.1277 130.316 44.6652 126.998 42.5761 123.803C40.3641 120.608 46.3857 110.777 46.8772 101.929C46.8772 101.929 48.1061 90.8692 40.9786 94.8016C33.851 98.857 31.5161 127.367 31.5161 130.562C31.5161 133.757 55.4794 138.304 67.8912 139.41C69.9803 140.639 72.561 141.745 75.1417 141.868C85.7101 141.991 88.1679 132.651 86.0788 132.529Z"
      fill="url(#paint8_linear_293_25600)"
    />
    <path
      d="M48.5977 101.192C48.5977 101.192 47.9832 90.9919 40.8557 95.0472C37.169 97.1363 33.4823 108.073 30.6559 115.078C34.8341 118.273 39.2581 119.871 44.0508 120.731C45.6483 118.027 49.4579 110.531 48.5977 101.192Z"
      fill="#085C42"
    />
    <defs>
      <filter
        id="filter0_d_293_25600"
        x="0.886719"
        y="204.584"
        width="481.328"
        height="308.395"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_293_25600"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_293_25600"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_293_25600"
        x1="362.195"
        y1="84.3399"
        x2="335.64"
        y2="88.4854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE2C4" />
        <stop offset="1" stopColor="#FFB870" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_293_25600"
        x1="344.645"
        y1="144.204"
        x2="325.507"
        y2="147.191"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB870" />
        <stop offset="1" stopColor="#FFE2C4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_293_25600"
        x1="304.535"
        y1="135.573"
        x2="298.506"
        y2="136.514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB870" />
        <stop offset="1" stopColor="#FFE2C4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_293_25600"
        x1="70.9241"
        y1="107.179"
        x2="109.649"
        y2="107.179"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB870" />
        <stop offset="1" stopColor="#FFE2C4" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_293_25600"
        x1="50.9675"
        y1="171.967"
        x2="112.811"
        y2="171.967"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE2C4" />
        <stop offset="1" stopColor="#FFB870" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_293_25600"
        x1="36.4831"
        y1="183.43"
        x2="93.0384"
        y2="183.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE2C4" />
        <stop offset="1" stopColor="#FFB870" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_293_25600"
        x1="49.5975"
        y1="74.1051"
        x2="76.1525"
        y2="78.2506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE2C4" />
        <stop offset="1" stopColor="#FFB870" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_293_25600"
        x1="107.257"
        y1="125.338"
        x2="113.287"
        y2="126.279"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB870" />
        <stop offset="1" stopColor="#FFE2C4" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_293_25600"
        x1="31.2885"
        y1="118.158"
        x2="86.7544"
        y2="118.158"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB870" />
        <stop offset="1" stopColor="#FFE2C4" />
      </linearGradient>
    </defs>
  </svg>
);
